/** Literal catalogue keys of the server settings screen (spec §8.26), so the catalogue test sees
 *  every one in the source. Generated from the same table as the catalogues; edit both together. */

export const GROUP: Record<string, string> = {
  "mcp": "server.group.mcp",
  "llm": "server.group.llm",
  "decision": "server.group.decision",
  "extraction": "server.group.extraction",
  "signin": "server.group.signin",
  "web": "server.group.web",
  "graph": "server.group.graph",
  "transfer": "server.group.transfer",
  "sessions": "server.group.sessions",
  "rail": "server.group.rail",
};

export const GROUP_SUB: Record<string, string> = {
  "mcp": "server.group.mcp.sub",
  "llm": "server.group.llm.sub",
  "decision": "server.group.decision.sub",
  "extraction": "server.group.extraction.sub",
  "signin": "server.group.signin.sub",
  "web": "server.group.web.sub",
  "graph": "server.group.graph.sub",
  "transfer": "server.group.transfer.sub",
  "sessions": "server.group.sessions.sub",
  "rail": "server.group.rail.sub",
};

export const SETTING: Record<string, string> = {
  "KM_MCP_ENABLED": "server.setting.KM_MCP_ENABLED",
  "KM_MCP_MAX_TOKENS": "server.setting.KM_MCP_MAX_TOKENS",
  "KM_MCP_RATE_LIMIT": "server.setting.KM_MCP_RATE_LIMIT",
  "KM_MCP_INLINE_MAX_BYTES": "server.setting.KM_MCP_INLINE_MAX_BYTES",
  "KM_RAIL_BUNDLE_OVERLAP": "server.setting.KM_RAIL_BUNDLE_OVERLAP",
  "KM_RAIL_BUNDLE_GROUPS": "server.setting.KM_RAIL_BUNDLE_GROUPS",
  "KM_LLM_BASE_URL": "server.setting.KM_LLM_BASE_URL",
  "KM_LLM_MODEL": "server.setting.KM_LLM_MODEL",
  "KM_LLM_API_KEY": "server.setting.KM_LLM_API_KEY",
  "KM_AUTO_EXTRACT": "server.setting.KM_AUTO_EXTRACT",
  "KM_DECISION_BASE_URL": "server.setting.KM_DECISION_BASE_URL",
  "KM_DECISION_MODEL": "server.setting.KM_DECISION_MODEL",
  "KM_DECISION_PROTOCOL": "server.setting.KM_DECISION_PROTOCOL",
  "KM_DECISION_TIMEOUT": "server.setting.KM_DECISION_TIMEOUT",
  "KM_DECISION_COOLDOWN_S": "server.setting.KM_DECISION_COOLDOWN_S",
  "KM_DECISION_ACCEPT": "server.setting.KM_DECISION_ACCEPT",
  "KM_DECISION_ACCEPT_LOGPROBS": "server.setting.KM_DECISION_ACCEPT_LOGPROBS",
  "KM_EXTRACTION_MAX_NODES": "server.setting.KM_EXTRACTION_MAX_NODES",
  "KM_FILE_TEXT_MAX_BYTES": "server.setting.KM_FILE_TEXT_MAX_BYTES",
  "KM_FILE_PROMPT_MAX_BYTES": "server.setting.KM_FILE_PROMPT_MAX_BYTES",
  "KM_PASSWORD_LOGIN": "server.setting.KM_PASSWORD_LOGIN",
  "KM_OIDC_LABEL": "server.setting.KM_OIDC_LABEL",
  "KM_OIDC_REQUIRED_GROUP": "server.setting.KM_OIDC_REQUIRED_GROUP",
  "KM_WEB_BROWSING": "server.setting.KM_WEB_BROWSING",
  "KM_WEB_RECORD_MAX_BYTES": "server.setting.KM_WEB_RECORD_MAX_BYTES",
  "KM_WEB_SNAPSHOT_MAX_BYTES": "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES",
  "KM_WEB_DOM_MAX_BYTES": "server.setting.KM_WEB_DOM_MAX_BYTES",
  "KM_WEB_TOKEN_IDLE_S": "server.setting.KM_WEB_TOKEN_IDLE_S",
  "KM_WEB_SESSION_TTL_S": "server.setting.KM_WEB_SESSION_TTL_S",
  "KM_GRAPH_MAX_ROWS": "server.setting.KM_GRAPH_MAX_ROWS",
  "KM_GRAPH_TIMEOUT_S": "server.setting.KM_GRAPH_TIMEOUT_S",
  "KM_TRANSFER_MAX_BYTES": "server.setting.KM_TRANSFER_MAX_BYTES",
  "KM_TRANSFER_TTL_S": "server.setting.KM_TRANSFER_TTL_S",
  "KM_SYNC_TOKEN_TTL_S": "server.setting.KM_SYNC_TOKEN_TTL_S",
};

export const SETTING_HELP: Record<string, string> = {
  "KM_MCP_ENABLED": "server.setting.KM_MCP_ENABLED.help",
  "KM_MCP_MAX_TOKENS": "server.setting.KM_MCP_MAX_TOKENS.help",
  "KM_MCP_RATE_LIMIT": "server.setting.KM_MCP_RATE_LIMIT.help",
  "KM_MCP_INLINE_MAX_BYTES": "server.setting.KM_MCP_INLINE_MAX_BYTES.help",
  "KM_RAIL_BUNDLE_OVERLAP": "server.setting.KM_RAIL_BUNDLE_OVERLAP.help",
  "KM_RAIL_BUNDLE_GROUPS": "server.setting.KM_RAIL_BUNDLE_GROUPS.help",
  "KM_LLM_BASE_URL": "server.setting.KM_LLM_BASE_URL.help",
  "KM_LLM_MODEL": "server.setting.KM_LLM_MODEL.help",
  "KM_LLM_API_KEY": "server.setting.KM_LLM_API_KEY.help",
  "KM_AUTO_EXTRACT": "server.setting.KM_AUTO_EXTRACT.help",
  "KM_DECISION_BASE_URL": "server.setting.KM_DECISION_BASE_URL.help",
  "KM_DECISION_MODEL": "server.setting.KM_DECISION_MODEL.help",
  "KM_DECISION_PROTOCOL": "server.setting.KM_DECISION_PROTOCOL.help",
  "KM_DECISION_TIMEOUT": "server.setting.KM_DECISION_TIMEOUT.help",
  "KM_DECISION_COOLDOWN_S": "server.setting.KM_DECISION_COOLDOWN_S.help",
  "KM_DECISION_ACCEPT": "server.setting.KM_DECISION_ACCEPT.help",
  "KM_DECISION_ACCEPT_LOGPROBS": "server.setting.KM_DECISION_ACCEPT_LOGPROBS.help",
  "KM_EXTRACTION_MAX_NODES": "server.setting.KM_EXTRACTION_MAX_NODES.help",
  "KM_FILE_TEXT_MAX_BYTES": "server.setting.KM_FILE_TEXT_MAX_BYTES.help",
  "KM_FILE_PROMPT_MAX_BYTES": "server.setting.KM_FILE_PROMPT_MAX_BYTES.help",
  "KM_PASSWORD_LOGIN": "server.setting.KM_PASSWORD_LOGIN.help",
  "KM_OIDC_LABEL": "server.setting.KM_OIDC_LABEL.help",
  "KM_OIDC_REQUIRED_GROUP": "server.setting.KM_OIDC_REQUIRED_GROUP.help",
  "KM_WEB_BROWSING": "server.setting.KM_WEB_BROWSING.help",
  "KM_WEB_RECORD_MAX_BYTES": "server.setting.KM_WEB_RECORD_MAX_BYTES.help",
  "KM_WEB_SNAPSHOT_MAX_BYTES": "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES.help",
  "KM_WEB_DOM_MAX_BYTES": "server.setting.KM_WEB_DOM_MAX_BYTES.help",
  "KM_WEB_TOKEN_IDLE_S": "server.setting.KM_WEB_TOKEN_IDLE_S.help",
  "KM_WEB_SESSION_TTL_S": "server.setting.KM_WEB_SESSION_TTL_S.help",
  "KM_GRAPH_MAX_ROWS": "server.setting.KM_GRAPH_MAX_ROWS.help",
  "KM_GRAPH_TIMEOUT_S": "server.setting.KM_GRAPH_TIMEOUT_S.help",
  "KM_TRANSFER_MAX_BYTES": "server.setting.KM_TRANSFER_MAX_BYTES.help",
  "KM_TRANSFER_TTL_S": "server.setting.KM_TRANSFER_TTL_S.help",
  "KM_SYNC_TOKEN_TTL_S": "server.setting.KM_SYNC_TOKEN_TTL_S.help",
};

/** Labels of a choice setting's values; a value without one shows as it is (e.g. a protocol name). */
export const CHOICE: Record<string, Record<string, string>> = {
  "KM_RAIL_BUNDLE_OVERLAP": { larger: "server.choice.KM_RAIL_BUNDLE_OVERLAP.larger", origin: "server.choice.KM_RAIL_BUNDLE_OVERLAP.origin" },
  "KM_RAIL_BUNDLE_GROUPS": { bundle: "server.choice.KM_RAIL_BUNDLE_GROUPS.bundle", separate: "server.choice.KM_RAIL_BUNDLE_GROUPS.separate" },
};

export const SOURCE: Record<string, string> = {
  "saved": "server.source.saved",
  "environment": "server.source.environment",
  "default": "server.source.default",
};

export const ERROR: Record<string, string> = {
  "type": "server.error.type",
  "integer": "server.error.integer",
  "range": "server.error.range",
  "choice": "server.error.choice",
  "required": "server.error.required",
  "length": "server.error.length",
  "url": "server.error.url",
  "host": "server.error.host",
  "unknown": "server.error.unknown",
  "password": "server.error.password",
};

export const TEST: Record<string, string> = {
  "answered": "server.test.answered",
  "format": "server.test.format",
  "reached": "server.test.reached",
  "model_missing": "server.test.model_missing",
  "http": "server.test.http",
  "timeout": "server.test.timeout",
  "unreachable": "server.test.unreachable",
  "unparseable": "server.test.unparseable",
  "url": "server.test.url",
  "host": "server.test.host",
};

export const TAB: Record<string, string> = {
  "settings": "server.tab.settings",
  "users": "server.tab.users",
  "history": "server.tab.history",
};

export const REFUSED: Record<string, string> = {
  "self": "server.users.refused.self",
  "last_admin": "server.users.refused.last_admin",
  "oidc": "server.users.refused.oidc",
  "system": "server.users.refused.system",
  "username_taken": "server.users.refused.username_taken",
};

export const FIELD: Record<string, string> = {
  "displayName": "server.users.field.displayName",
  "email": "server.users.field.email",
};

export const HISTORY: Record<string, string> = {
  "mcp.token_created": "server.history.mcp.token_created",
  "mcp.token_revoked": "server.history.mcp.token_revoked",
  "mcp.tokens_revoked": "server.history.mcp.tokens_revoked",
  "mcp.write": "server.history.mcp.write",
  "setting.saved": "server.history.setting.saved",
  "setting.reset": "server.history.setting.reset",
  "user.created": "server.history.user.created",
  "user.edited": "server.history.user.edited",
  "user.password": "server.history.user.password",
  "user.admin.on": "server.history.user.admin.on",
  "user.admin.off": "server.history.user.admin.off",
  "user.active.on": "server.history.user.active.on",
  "user.active.off": "server.history.user.active.off",
};
